class AlgoliaProductCard extends window.BAOv2.CustomElement {
  connectedCallback () {
    this.init()
    this.lazyVideo()
    this.setupListeners()
  }

  init () {
    const variantButtons = this.els.button.elements
    const variantSelect = this.els.select.element
    const variantID = this.els.id.element

    variantButtons.forEach(variantButton => {
      variantButton.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()

        const sel = variantID

        const variant = variantButton.dataset.productVariant

        variantSelect.value = variant

        if (sel) {
          const opts = sel.options
          for (let opt, j = 0; (opt = opts[j]); j++) {
            if (opt.text === variant) {
              sel.selectedIndex = j
              break
            }
          }
        }

        const event = new Event('change', {
          bubbles: true,
        })

        variantSelect.dispatchEvent(event)

        variantButtons.forEach(el => el.setAttribute('aria-selected', String(el === variantButton)))

        const form = this.els.form.element
        form && form.querySelector('.js-AddToCart_Submit').click()
      })
    })
  }

  lazyVideo () {
    const productCardEl = this.closest('.prd-Card')
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0,
    })

    observer.observe(productCardEl)

    function observerCallback (entries, observer) {
      const isIntersecting = entries.some(entry => entry.isIntersecting)

      if (!isIntersecting) return

      const videoEl = entries[0].target.querySelector('.prd-Card_Video-player')

      if (!videoEl) return
      const videoSrc = videoEl?.dataset.videoSrc

      videoEl.setAttribute('src', videoSrc)
      videoEl.play()

      observer.disconnect()
    }
  }
}

if (!customElements.get('algolia-product-card')) {
  customElements.define('algolia-product-card', AlgoliaProductCard)
}
